import React from "react";
import { Link } from "react-router-dom";

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block ar-rise"
      style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }}
    >
      <div className="relative overflow-hidden bg-sand aspect-[3/4] flex items-center justify-center">
        <img
          src={product.image}
          alt={`${product.styleCode} — ${product.name}`}
          loading="lazy"
          className="w-full h-full object-contain p-3 transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-white/92 backdrop-blur-sm text-ink text-[10px] font-mono uppercase tracking-[0.1em] px-2.5 py-1 max-w-[88%] truncate">
            {product.badge}
          </span>
        )}
      </div>
      <div className="pt-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-denim">{product.styleCode}</p>
        <h3 className="mt-1 text-sm font-heading font-semibold text-ink leading-tight group-hover:text-navy transition-colors">{product.name}</h3>
        {product.sub && <p className="mt-1 text-[11px] text-muted-foreground leading-snug line-clamp-1">{product.sub}</p>}
      </div>
    </Link>
  );
};
